import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ParkingMallsListComponent } from './components/parking-malls/parking-malls-list/parking-malls-list.component';
import { SessionsListComponent } from './components/sessions/sessions-list/sessions-list.component';
import { TrafficComponent } from './components/traffic/traffic.component';
import { OccupancyComponent } from './components/occupancy/occupancy.component';
import { PhotoLogComponent } from './components/photo-log/photo-log.component';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'parking-malls', component: ParkingMallsListComponent },
  { path: 'sessions', component: SessionsListComponent },
  { path: 'traffic', component: TrafficComponent },
  { path: 'occupancy', component: OccupancyComponent },
  { path: 'photo-log', component: PhotoLogComponent },
  { path: '**', redirectTo: '/dashboard' }
];
